
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payment-method/[customer_id]",
      function () {
        return require("private-next-pages/payment-method/[customer_id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/payment-method/[customer_id]"])
      });
    }
  